//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[[0,"ColorIndex",1,0],[0,"ColorName",1,0],[0,"FavoriteIndex",1,0]],[[[],"GetColorValues",{R_:{colorVals:''}},0,0],[["colorVals"],"SetColorValues",{},1,0]],[]];
SPLM.ColorDefinition = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.ColorDefinition";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ColorDefinitionRgb = class{
    constructor(red,green,blue){
        this.red=red;this.green=green;this.blue=blue;}
    get Red(){return this.red}
    set Red(val){this.red = val}
    get Green(){return this.green}
    set Green(val){this.green = val}
    get Blue(){return this.blue}
    set Blue(val){this.blue = val}
};

export default SPLM;